import { toast } from "react-toastify";
import { ErrorTypeEnum } from "./errorTypeEnum";

export const showError = (er: any) => {
  if (!getErrorTypeEnumsOptions(er.response.data.errorCode)) {
    try {
      toast.error(er.response.data.message);
    } catch (error) {
      toast.error("Error desconocido/No definido");
    }
  }
  try {
    console.error(er.response.data.message);
  } catch (error) {
    console.error("Error desconocido/No definido");
  }
};

export const getErrorTypeEnumsOptions = (errorTypeEnum: ErrorTypeEnum) => {
  var result = "";
  switch (errorTypeEnum) {
    case ErrorTypeEnum.UndefinedError:
      result = "Error indeterminado";
      break;
    // adaptacion 1xx
    case ErrorTypeEnum.DefaultAdapter_JsonTransformException:
      result = "Error de formato en el JSON recibido";
      break;
    case ErrorTypeEnum.DefaultAdapter_GeneralException:
      result = "Error indeterminado. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.DefaultAdapter_NullParameterException:
      result =
        "Faltan parametros para la ejecución del proceso. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.Adapter_RedirectException:
      result =
        "Error al redireccionar al paso de cargue de datos del documento. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.Adapter_DocumentLinesRequired:
      result = "El comprobante debe tener al menos una linea de detalle";
      break;
    case ErrorTypeEnum.Adapter_DocumentLineExtensionAmount:
      result =
        "El valor total antes de tributos no coincide con la suma de los items del documento";
      break;
    case ErrorTypeEnum.Adapter_DocumentTaxExclusiveAmount:
      result =
        "La base imponible total no coincide con la suma de los items del documento";
      break;
    case ErrorTypeEnum.Adapter_DocumentTaxInclusiveAmount:
      result =
        "El valor total con tributos  no coincide con la suma de los items del documento";
      break;

    // Cargue de datos 2xx
    case ErrorTypeEnum.CUFEGeneration_TechnicalKeyEmpty:
      result = "Error al generar CUFE/CUDE, la clave técnica esta vacia";
      break;

    case ErrorTypeEnum.LoadData_TechnicalError:
      result = "Error indeterminado.  Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadLegalData_DianResolutionNoExists:
      result = "La resolución indicada no existe en el sistema";
      break;
    case ErrorTypeEnum.LoadLegalData_DuplicatedDianResolutions:
      result =
        "Varias resoluciones coinciden con los datos suministrados, el sistema no puede determinar cual de ellas utilizar. Por favor verifique.";
      break;
    case ErrorTypeEnum.LoadLegalData_SupplierInfoEmpty:
      result = "La información del OFE es insuficiente. Por favor verifique.";
      break;
    case ErrorTypeEnum.LoadLegalData_CertificateNoFound:
      result = "No se encuentró certificado digital vigente";
      break;
    case ErrorTypeEnum.LoadLegalData_DocumentNull:
      result =
        "El documento recibido esta vacío.  Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadData_TransformRequestEmptyTrackid:
      result = "No se recibió un trackId válido. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadData_TransformRequestEmptyContent:
      result =
        "El documento es vacío o es inválido. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadData_TransformRequestEmptyRequest:
      result =
        "La solicitud recibida esta vacía o inválida. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadData_TransformRequestJsonError:
      result =
        "El JSON del documento esta vacío o es inválido.  Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadData_PreviousApprovedDocument:
      result =
        "El documento que esta tratando de procesar fue aprobado anteriormente";
      break;

    case ErrorTypeEnum.LoadLegalData_ConsecutiveOutOfRange:
      result =
        "Consecutivo fuera del rango de consecutivos dados por la resolución";
      break;
    case ErrorTypeEnum.LoadLegalData_DateOutOfRange:
      result =
        "Fecha del documento fuera del rango de fechas dados por la resolución";
      break;

    case ErrorTypeEnum.LoadData_PackagesWithoutBalance:
      result =
        "No tienes saldo para enviar documentos electrónicos. Por favor adquiere mas paquetes o contacta a tu proveedor de software.";
      break;
    case ErrorTypeEnum.LoadData_PackagesReadError:
      result =
        "No tienes paquetes de documentos registrados. Por favor adquiere un paquete o contacta a tu proveedor de software.";
      break;

    case ErrorTypeEnum.CUFEGeneration_SoftwarePinEmpty:
      result =
        "El pin del software esta vacío.  Por favor verifique la configuracon de su empresa.";
      break;
    case ErrorTypeEnum.CUFEGeneration_SoftwareIdEmpty:
      result =
        "Identificador del software esta vacío. Por favor verifique la configuracon de su empresa.";
      break;
    case ErrorTypeEnum.CUFEGeneration_SecurityCodeError:
      result =
        "Error calculando el código de seguridad del documento. Por favor contacte a soporte.";
      break;
    case ErrorTypeEnum.CUFEGeneration_InvoiceCufeError:
      result =
        "Error generando el CUFE para la factura. Por favor contacte a soporte.";
      break;
    case ErrorTypeEnum.CUFEGeneration_CreditNoteCufeError:
      result =
        "Error generando el CUDE para la nota crédito.  Por favor contacte a soporte.";
      break;
    case ErrorTypeEnum.CUFEGeneration_DebitNoteCufeError:
      result =
        "Error generando el CUDE para la nota débito.  Por favor contacte a soporte.";
      break;
    case ErrorTypeEnum.CUFEGeneration_ContingenceCufeError:
      result =
        "Error generando el CUFE para la factura de contingencia.  Por favor contacte a soporte.";
      break;

    // XMLGeneration 3xx
    case ErrorTypeEnum.XMLGeneration_GeneralError:
      result = "Error en la transformacion XSD. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.XMLGeneration_TechnicalError:
      result = "UnUsed";
      break;
    case ErrorTypeEnum.XMLGeneration_ConvertToXML:
      result =
        "Error al generar el XML previo a la conversion XSD. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.XMLGeneration_RedirectException:
      result =
        "Error al redireccionar al paso de firmado del documento. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.AttachedDocumentObjectCreationError:
      result =
        "Error general construyendo el attached document. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.AttachedDocumentDocumentTransformError:
      result = "Error en la transformación del attached document";
      break;

    // firma del documento 4xx
    case ErrorTypeEnum.LoadCert_Error:
      result =
        "Error general al cargar el certificado. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadCert_ByPathError:
      result =
        "Error al leer el certificado para la ruta especifica. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadCert_MemoryStreamNull:
      result =
        "No se pudo crear el objeto MemoryStream para usar el certificado. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.LoadCert_ReadPasswordError:
      result =
        "Error al leer/decodificar el password del certificado. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.Sign_NoTenantFound:
      result =
        "No se encontró Tenant para el proceso de firma. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.Sign_XMLSignException:
      result =
        "Error general en el firmado del documento. Por favor contacte a soporte";
      break;

    case ErrorTypeEnum.SignCall_GeneralError:
      result =
        "Error al llamar al servicio de firma del documento. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.SignCall_ErrorResponse:
      result =
        "El servicio de firmado no respondió satisfactoriamente. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SignCall_DeserializationError:
      result =
        "Error al deserializar la respuesta de la firma. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SignCall_RequestNullOrEmpty:
      result = "UnUsed";
      break;

    // envio de documento 5xx
    case ErrorTypeEnum.SendDocument_TestSendGeneralError:
      result =
        "Error al invocar el servicio de envio de documentos. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SendDocument_ProductionSendGeneralError:
      result =
        "Error al enviar el documento a produccion. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SendDocument_ProductionTestSendGeneralError:
      result =
        "Error al enviar el documento en ambiente de prueba. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SendDocument_NoTenantFound:
      result =
        "No se encontró Tenant para el proceso de envio de documento. Por favor contacte a soporte ";
      break;

    case ErrorTypeEnum.SendCall_GeneralError:
      result =
        "Error al invocar el servicio de envio de documentos.  Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SendCall_ErrorResponse:
      result =
        "El servicio de envío de documentos no respondió satisfactoriamente. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SendCall_DeserializationError:
      result =
        "Error al deserializar la respuesta del envio de documentos. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.CheckZipKey_DeserializationError:
      result =
        "Error en la deserialización del resultado de la validación del documento prueba";
      break;
    case ErrorTypeEnum.CheckZipKey_ErrorResponse:
      result = "Documento de prueba rechazado por la DIAN";
      break;
    case ErrorTypeEnum.CheckZipKey_GeneralError:
      result =
        "Error generan el la recepción de resultado de la validación del documento prueba";
      break;

    // errores retornados por la dian 6xx
    case ErrorTypeEnum.DianResponse_AsyncGenericError:
      result = "Envío asíncrono con errores reportados por la DIAN";
      break;
    case ErrorTypeEnum.DianResponse_SyncGenericError:
      result = "Envío síncrono con errores reportados por la DIAN";
      break;
    case ErrorTypeEnum.DianResponse_DeserializationError:
      result =
        "Error en la deserialización del resultado del envio. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.DianResponse_RejectedGenericError:
      result = "Documento rechazado por la dian.";
      break;

    // Gestion certificados 90x
    case ErrorTypeEnum.SaveCertificate_DirectoryError:
      result =
        "Error al crear/encontrar el directorio para almacenar el certificado. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SaveCertificate_CertFileWriteError:
      result =
        "Error al escribir el archivo de certificado. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SaveCertificate_PassFileWriteError:
      result = "Error al guardar el password. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.SaveCertificate_NoTenantFound:
      result =
        "No se encontró Tenant para el proceso de almacenamiento del certificado. Por favor contacte a soporte ";
      break;

    // Gestion resoluciones 92x
    case ErrorTypeEnum.SincResolutions_NoTenantFound:
      result =
        "No se encontró Tenant para el proceso de sincronización de resoluciones";
      break;
    case ErrorTypeEnum.SincResolutions_NoResolutionsAsociatedError:
      result =
        "No se encontraron resoluciones registradas para el NIT del OFE.";
      break;
    case ErrorTypeEnum.SincResolutions_NoSuccessCallService:
      result =
        "Error al consultar el servicio de resoluciones de la DIAN. Por favor contacte a soporte ";
      break;

    // errores de envio de email
    case ErrorTypeEnum.Email_GeneralException:
      result =
        "Error genérico en el envio via email. Por favor contacte a soporte";
      break;
    case ErrorTypeEnum.InvalidTargetEmail:
      result = "Email del destinatario inválido";
      break;
    case ErrorTypeEnum.InvalidSourceEmail:
      result = "Email del remitente inválido";
      break;
    case ErrorTypeEnum.InvalidContent:
      result = "Contenido del email inválido";
      break;
    case ErrorTypeEnum.EmptyTargetEmail:
      result = "Email del remitente no puede ser vacío";
      break;
    case ErrorTypeEnum.EmailTemplateLoadingError:
      result =
        "Error al cargar el template para envio del email. Por favor contacte a soporte ";
      break;
    case ErrorTypeEnum.Email_SupplierWithoutShippingEnable:
      result =
        "La empresa no tiene habilitado el envío manual de correos. Puede cambiarlo en Mi empresa > Notificaciones";
      break;
    case ErrorTypeEnum.Email_NoAttachFileFound:
      result = "No se encontró Attached Document para enviar";
      break;
    case ErrorTypeEnum.Email_NoEmailTargetsFound:
      result = "No hay emails destinatarios para realizar el envío";
      break;
    case ErrorTypeEnum.Email_SupplierWithoutAutoShippingEnable:
      result = "El OFE no tiene habilitado el envío automatico de emails";
      break;
    case ErrorTypeEnum.Email_SuccessDescription:
      result = "Envío exitoso";
      break;
    case ErrorTypeEnum.Email_SendProcessError:
      result = "Envío en proceso";
      break;

    // errores de Autenticacion / Autorizacion
    case ErrorTypeEnum.WrongUsernameOrPassword:
      result = "Usuario o contraseña incorrectos";
      break;
    case ErrorTypeEnum.AuthorizationStringEmptyOrNull:
      result = "Información de autorización no puede estar vacía";
      break;
    case ErrorTypeEnum.UnauthorizedAction:
      result = "El usuario no tiene permisos para realizar esta acción";
      break;
    case ErrorTypeEnum.UserAlreadyExists:
      result = "El usuario ya existe";
      break;
    case ErrorTypeEnum.TenantAlreadyExists:
      result = "El tenant ya existe";
      break;
    case ErrorTypeEnum.InactiveUser:
      result = "El usuario se encuentra inactivo";
      break;

    // errores validacion
    case ErrorTypeEnum.DatabaseErrorValidation:
      result = "Error de validación en base de datos";
      break;
    case ErrorTypeEnum.RequestErrorValidation:
      result = "Solicitud no cumple con las validaciones requeridas";
      break;
    case ErrorTypeEnum.InvalidImageExtension:
      result = "Extensión de la imagen inválida";
      break;
    case ErrorTypeEnum.ObjectIsNull:
      result = "El objeto esta vacío o nulo";
      break;
    case ErrorTypeEnum.StringIsNullOrEmpty:
      result = "La cadena esta vacía o nulo";
      break;
    case ErrorTypeEnum.CompanyKeyNotFound:
      result = "CompanyKey no encontrado";
      break;

    // errores globales
    case ErrorTypeEnum.UnknownError:
      result = "Error desconocido";
      break;
    case ErrorTypeEnum.FileNotFound:
      result = "Archivo no encontrado";
      break;
    case ErrorTypeEnum.KeyInListOfValuesNotFound:
      result = "Llave no encontrado en la lista de valores";
      break;

    // errores en manejo de certificado digital
    case ErrorTypeEnum.NoActiveCertificateWasFound:
      result = "Para sincronizar resoluciones debes contar con un certificado digital activo";
      break;
    case ErrorTypeEnum.ErrorSavingCertificate:
      result = "Error guardando el certificado";
      break;
    case ErrorTypeEnum.CertificateAlreadyExist:
      result = "El certificado ya existe en el sistema";
      break;
    case ErrorTypeEnum.ErrorReadingCertificate:
      result = "Error leyendo el certificado";
      break;

    // errores en gestion de representacion grafica  17xx
    case ErrorTypeEnum.GraphicRep_EmptyParametersOnLoadFile:
      result = "Error al cargar la representación gráfica, faltan parámetros";
      break;
    case ErrorTypeEnum.GraphicRep_ErrorSavingFile:
      result = "Error guardando el archivo de representación gráfica";
      break;
    case ErrorTypeEnum.GraphicRep_ErrorParsing64baseToBytes:
      result = "Error deserializando el base64 de la representación gráfica";
      break;

    // errores en set de pruebas 18xx
    case ErrorTypeEnum.TestSet_NullParameters:
      result =
        "Error en set de pruebas no existen parámetros para la generación de réplicas";
      break;
    case ErrorTypeEnum.TestSet_NoEnougthParameters:
      result =
        "Error en set de pruebas faltan parámetros para la generación de réplicas";
      break;
    case ErrorTypeEnum.TestSet_BaseInvoiceNoFound:
      result = "Error en set de pruebas factura base no encontrada";
      break;
    case ErrorTypeEnum.TestSet_SourceFromBaseInvoiceNoFound:
      result =
        "Error en set de pruebas fuente de la factura base no encontrada";
      break;
    case ErrorTypeEnum.TestSet_DeserializationError:
      result =
        "Error en set de pruebas error en la deserialización de fuente de la factura base ";
      break;

    //Descripciones de acciones
    case ErrorTypeEnum.RejectedByCustomer_Description:
      result = "Documento rechazado por cliente";
      break;
    case ErrorTypeEnum.RejectByUser_Description:
      result = "Documento rechazado por el usuario";
      break;
  }
  if (result === "") {
    return false;
  } else {
    toast.error(result);
    return true;
  }
};
